// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"BB-z","smallCardRow":"CB-z","largeCardRow":"DB-z","productSearchRow":"EB-z","curatedRow":"FB-z"};